// toast.ts
import { message } from 'antd';

// Generic toast utility
type ToastType = 'success' | 'error' | 'info' | 'warning' | 'loading';
 
export const toast = (type: ToastType, content: string, duration: number = 2) => {
  message.open({
    type,
    content,
    duration,
  });
};
